// -------------
// this is the registration of all default expression elements
// -------------
import { RegisterExpressionRuleEditor } from "./Utilities/RegisterExpressionRuleEditor";
import { DateGetSecondExpressionEditor } from "./Expressions/Date/DateGetSecondExpressionEditor";
import { MultiplyExpressionEditor } from "./Expressions/Math/MultiplyExpressionEditor";
import { IsFalseExpressionEditor } from "./Expressions/Logic/IsFalseExpressionEditor";
import { AsPercentageExpressionEditor } from "./Expressions/Math/AsPercentageExpressionEditor";
import { StringListNotContainsExpressionEditor } from "./Expressions/String/StringListNotContainsExpressionEditor";
import { StringListContainsExpressionEditor } from "./Expressions/String/StringListContainsExpressionEditor";
import { StringContainsExpressionEditor } from "./Expressions/String/StringContainsExpressionEditor";
import { DateLessThanExpressionEditor } from "./Expressions/Date/DateLessThanExpressionEditor";
import { SubstractExpressionEditor } from "./Expressions/Math/SubstractExpressionEditor";
import { StringListAllInExpressionEditor } from "./Expressions/String/StringListAllInExpressionEditor";
import { RootExpressionEditor } from "./Utilities/RootExpressionEditor";
import { AverageExpressionEditor } from "./Expressions/Math/AverageExpressionEditor";
import { AsCurrencyExpressionEditor } from "./Expressions/Math/AsCurrencyExpressionEditor";
import { StringLowercaseExpressionEditor } from "./Expressions/String/StringLowercaseExpressionEditor";
import { MaxExpressionEditor } from "./Expressions/Math/MaxExpressionEditor";
import { OrGroupEditor } from "./Expressions/Logic/OrGroupEditor";
import { StringListNotAllInExpressionEditor } from "./Expressions/String/StringListNotAllInExpressionEditor";
import { AbsoluteExpressionEditor } from "./Expressions/Math/AbsoluteExpressionEditor";
import { StringEqualExpressionEditor } from "./Expressions/String/StringEqualExpressionEditor";
import { GreaterThanExpressionEditor } from "./Expressions/Logic/GreaterThanExpressionEditor";
import { DateGetHourExpressionEditor } from "./Expressions/Date/DateGetHourExpressionEditor";
import { StringEndWithExpressionEditor } from "./Expressions/String/StringEndWithExpressionEditor";
import { StringListInExpressionEditor } from "./Expressions/String/StringListInExpressionEditor";
import { DateEqualToExpressionEditor } from "./Expressions/Date/DateEqualToExpressionEditor";
import { DateGetMonthExpressionEditor } from "./Expressions/Date/DateGetMonthExpressionEditor";
import { RoundExpressionEditor } from "./Expressions/Math/RoundExpressionEditor";
import { GreaterThanEqualToExpressionEditor } from "./Expressions/Logic/GreaterThanEqualToExpressionEditor";
import { EqualExpressionEditor } from "./Expressions/Math/EqualExpressionEditor";
import { StringNotContainsExpressionEditor } from "./Expressions/String/StringNotContainsExpressionEditor";
import { DateGetYearExpressionEditor } from "./Expressions/Date/DateGetYearExpressionEditor";
import { ExistsExpressionEditor } from "./Expressions/Logic/ExistsExpressionEditor";
import { StringListNotInExpressionEditor } from "./Expressions/String/StringListNotInExpressionEditor";
import { DateGetDayExpressionEditor } from "./Expressions/Date/DateGetDayExpressionEditor";
import { IsTrueExpressionEditor } from "./Expressions/Logic/IsTrueExpressionEditor";
import { StringTrimExpressionEditor } from "./Expressions/String/StringTrimExpressionEditor";
import { AddExpressionEditor } from "./Expressions/Math/AddExpressionEditor";
import { RandomExpressionEditor } from "./Expressions/Math/RandomExpressionEditor";
import { StringProperExpressionEditor } from "./Expressions/String/StringProperExpressionEditor";
import { StringUppercaseExpressionEditor } from "./Expressions/String/StringUppercaseExpressionEditor";
import { StringListGetStringByIndexExpressionEditor } from "./Expressions/String/StringListGetStringByIndexExpressionEditor";
import { StringLengthExpressionEditor } from "./Expressions/String/StringLengthExpressionEditor";
import { SumExpressionEditor } from "./Expressions/Math/SumExpressionEditor";
import { IfThenExpressionEditor } from "./Expressions/Logic/IfThenExpressionEditor";
import { StringCombineExpressionEditor } from "./Expressions/String/StringCombineExpressionEditor";
import { DateGreaterThanExpressionEditor } from "./Expressions/Date/DateGreaterThanExpressionEditor";
import { StringStartWithExpressionEditor } from "./Expressions/String/StringStartWithExpressionEditor";
import { StringIsEmptyExpressionEditor } from "./Expressions/String/StringIsEmptyExpressionEditor";
import { NotExpressionEditor } from "./Expressions/Logic/NotExpressionEditor";
import { LessThanExpressionEditor } from "./Expressions/Logic/LessThanExpressionEditor";
import { LessThanEqualToExpressionEditor } from "./Expressions/Logic/LessThanEqualToExpressionEditor";
import { StringIsValidEmailExpressionEditor } from "./Expressions/String/StringIsValidEmailExpressionEditor";
import { StringIndexOfExpressionEditor } from "./Expressions/String/StringIndexOfExpressionEditor";
import { ModExpressionEditor } from "./Expressions/Math/ModExpressionEditor";
import { DateGetMinuteExpressionEditor } from "./Expressions/Date/DateGetMinuteExpressionEditor";
import { AndGroupEditor } from "./Expressions/Logic/AndGroupEditor";
import { StringListCombineExpressionEditor } from "./Expressions/String/StringListCombineExpressionEditor";
import { DivideExpressionEditor } from "./Expressions/Math/DivideExpressionEditor";
import { MinExpressionEditor } from "./Expressions/Math/MinExpressionEditor";
import { DateGetTodayExpressionEditor } from "./Expressions/Date/DateGetTodayExpressionEditor";
import { NotEqualExpressionEditor } from "./Expressions/Math/NotEqualExpressionEditor";
import { RootExpression } from "../rule-engine-core/Expressions/RootExpression";
import { AbsoluteExpression } from "../rule-engine-core/Expressions/Expressions/Math/AbsoluteExpression";
import { DateEqualToExpression } from "../rule-engine-core/Expressions/Expressions/Date/DateEqualToExpression";
import { DateGetDayExpression } from "../rule-engine-core/Expressions/Expressions/Date/DateGetDayExpression";
import { DateGetHourExpression } from "../rule-engine-core/Expressions/Expressions/Date/DateGetHourExpression";
import { DateGetMinuteExpression } from "../rule-engine-core/Expressions/Expressions/Date/DateGetMinuteExpression";
import { DateGetMonthExpression } from "../rule-engine-core/Expressions/Expressions/Date/DateGetMonthExpression";
import { DateGetSecondExpression } from "../rule-engine-core/Expressions/Expressions/Date/DateGetSecondExpression";
import { DateGetTodayExpression } from "../rule-engine-core/Expressions/Expressions/Date/DateGetTodayExpression";
import { DateGetYearExpression } from "../rule-engine-core/Expressions/Expressions/Date/DateGetYearExpression";
import { DateGreaterThanExpression } from "../rule-engine-core/Expressions/Expressions/Date/DateGreaterThanExpression";
import { DateLessThanExpression } from "../rule-engine-core/Expressions/Expressions/Date/DateLessThanExpression";
import { ExistsExpression } from "../rule-engine-core/Expressions/Expressions/Logic/Exists";
import { GreaterThanExpression } from "../rule-engine-core/Expressions/Expressions/Logic/GreaterThan";
import { GreaterThanEqualToExpression } from "../rule-engine-core/Expressions/Expressions/Logic/GreaterThanEqualTo";
import { AndGroup } from "../rule-engine-core/Expressions/Expressions/Logic/AndGroup";
import { OrGroup } from "../rule-engine-core/Expressions/Expressions/Logic/OrGroup";
import { IfThenExpression } from "../rule-engine-core/Expressions/Expressions/Logic/IfThenExpression";
import { IsFalseExpression } from "../rule-engine-core/Expressions/Expressions/Logic/IsFalse";
import { IsTrueExpression } from "../rule-engine-core/Expressions/Expressions/Logic/IsTrue";
import { LessThanExpression } from "../rule-engine-core/Expressions/Expressions/Logic/LessThanExpression";
import { LessThanEqualToExpression } from "../rule-engine-core/Expressions/Expressions/Logic/LessThanEqualToExpression";
import { NotExpression } from "../rule-engine-core/Expressions/Expressions/Logic/NotExpression";
import { AddExpression } from "../rule-engine-core/Expressions/Expressions/Math/AddExpression";
import { AsCurrencyExpression } from "../rule-engine-core/Expressions/Expressions/Math/AsCurrencyExpression";
import { AsPercentageExpression } from "../rule-engine-core/Expressions/Expressions/Math/AsPercentageExpression";
import { AverageExpression } from "../rule-engine-core/Expressions/Expressions/Math/AverageExpression";
import { DivideExpression } from "../rule-engine-core/Expressions/Expressions/Math/DivideExpression";
import { EqualExpression } from "../rule-engine-core/Expressions/Expressions/Math/EqualExpression";
import { MaxExpression } from "../rule-engine-core/Expressions/Expressions/Math/MaxExpression";
import { MinExpression } from "../rule-engine-core/Expressions/Expressions/Math/MinExpression";
import { ModExpression } from "../rule-engine-core/Expressions/Expressions/Math/ModExpression";
import { MultiplyExpression } from "../rule-engine-core/Expressions/Expressions/Math/MultiplyExpression";
import { SubstractExpression } from "../rule-engine-core/Expressions/Expressions/Math/SubstractExpression";
import { SumExpression } from "../rule-engine-core/Expressions/Expressions/Math/SumExpression";
import { NotEqualExpression } from "../rule-engine-core/Expressions/Expressions/Math/NotEqualExpression";
import { RandomExpression } from "../rule-engine-core/Expressions/Expressions/Math/RandomExpression";
import { RoundExpression } from "../rule-engine-core/Expressions/Expressions/Math/RoundExpression";
import { StringListCombineExpression } from "../rule-engine-core/Expressions/Expressions/String/StringListCombineExpression";
import { StringUppercaseExpression } from "../rule-engine-core/Expressions/Expressions/String/StringUppercaseExpression";
import { StringTrimExpression } from "../rule-engine-core/Expressions/Expressions/String/StringTrimExpression";
import { StringStartWithExpression } from "../rule-engine-core/Expressions/Expressions/String/StringStartWithExpression";
import { StringProperExpression } from "../rule-engine-core/Expressions/Expressions/String/StringProperExpression";
import { StringNotContainsExpression } from "../rule-engine-core/Expressions/Expressions/String/StringNotContainsExpression";
import { StringLowercaseExpression } from "../rule-engine-core/Expressions/Expressions/String/StringLowercaseExpression";
import { StringLengthExpression } from "../rule-engine-core/Expressions/Expressions/String/StringLengthExpression";
import { StringIsValidEmailExpression } from "../rule-engine-core/Expressions/Expressions/String/StringIsValidEmailExpression";
import { StringIsEmptyExpression } from "../rule-engine-core/Expressions/Expressions/String/StringIsEmptyExpression";
import { StringIndexOfExpression } from "../rule-engine-core/Expressions/Expressions/String/StringIndexOfExpression";
import { StringEndWithExpression } from "../rule-engine-core/Expressions/Expressions/String/StringEndWithExpression";
import { StringEqualExpression } from "../rule-engine-core/Expressions/Expressions/String/StringEqualExpression";
import { StringContainsExpression } from "../rule-engine-core/Expressions/Expressions/String/StringContainsExpression";
import { StringCombineExpression } from "../rule-engine-core/Expressions/Expressions/String/StringCombineExpression";
import { StringListNotContainsExpression } from "../rule-engine-core/Expressions/Expressions/String/StringListNotContainsExpression";
import { StringListNotAllInExpression } from "../rule-engine-core/Expressions/Expressions/String/StringListNotAllInExpression";
import { StringListNotInExpression } from "../rule-engine-core/Expressions/Expressions/String/StringListNotInExpression";
import { StringListAllInExpression } from "../rule-engine-core/Expressions/Expressions/String/StringListAllInExpression";
import { StringListInExpression } from "../rule-engine-core/Expressions/Expressions/String/StringListInExpression";
import { StringListGetStringByIndexExpression } from "../rule-engine-core/Expressions/Expressions/String/StringListGetStringByIndexExpression";
import { StringListContainsExpression } from "../rule-engine-core/Expressions/Expressions/String/StringListContainsExpression";
import { StringIsNotEmptyExpressionEditor } from "./Expressions/String/StringIsNotEmptyExpressionEditor";
import { StringIsNotEmptyExpression } from "../rule-engine-core/Expressions/Expressions/String/StringIsNotEmptyExpression";
import { AbsoluteIcon } from "../CommonUI/Icon/AbsoluteIcon";
import React from "react";
import { DateEqualToIcon } from "../CommonUI/Icon/DateEqualToIcon";
import { TextIcon } from "../CommonUI/TextIcon";
import { DateGreaterThanIcon } from "../CommonUI/Icon/DateGreaterThanIcon";
import { DateLessThanIcon } from "../CommonUI/Icon/DateLessThanIcon";
import { ExistsIcon } from "../CommonUI/Icon/ExistsIcon";
import { GreaterThanIcon } from "../CommonUI/Icon/GreaterThanIcon";
import { GreaterThanEqualIcon } from "../CommonUI/Icon/GreaterThanEqualIcon";
import { AndIcon } from "../CommonUI/Icon/AndIcon";
import { OrIcon } from "../CommonUI/Icon/OrIcon";
import { IfThenIcon } from "../CommonUI/Icon/IfThenIcon";
import { IsFalseIcon } from "../CommonUI/Icon/IsFalseIcon";
import { IsTrueIcon } from "../CommonUI/Icon/IsTrueIcon";
import { LessThanIcon } from "../CommonUI/Icon/LessThanIcon";
import { LessThanEqualIcon } from "../CommonUI/Icon/LessThanEqualIcon";
import { NotIcon } from "../CommonUI/Icon/NotIcon";
import { PlusOutlineIcon } from "../CommonUI/Icon/PlusOutlineIcon";
import { AsPercentageIcon } from "../CommonUI/Icon/AsPercentageIcon";
import { AverageIcon } from "../CommonUI/Icon/AverageIcon";
import { DevideIcon } from "../CommonUI/Icon/DevideIcon";
import { EqualIcon } from "../CommonUI/Icon/EqualIcon";
import { MaxIcon } from "../CommonUI/Icon/MaxIcon";
import { MinIcon } from "../CommonUI/Icon/MinIcon";
import { ModIcon } from "../CommonUI/Icon/ModIcon";
import { MultiplyIcon } from "../CommonUI/Icon/MultiplyIcon";
import { SubstractIcon } from "../CommonUI/Icon/SubstractIcon";
import { SumIcon } from "../CommonUI/Icon/SumIcon";
import { NotEqualIcon } from "../CommonUI/Icon/NotEqualIcon";
import { RandomIcon } from "../CommonUI/Icon/RandomIcon";
import { RoundIcon } from "../CommonUI/Icon/RoundIcon";
import { CombineIcon } from "../CommonUI/Icon/CombineIcon";
import { TextContainsIcon } from "../CommonUI/Icon/TextContainsIcon";
import { StartWithIcon } from "../CommonUI/Icon/StartWithIcon";
import { IndexOfIcon } from "../CommonUI/Icon/IndexOfIcon";
import { TextEmptyIcon } from "../CommonUI/Icon/TextEmptyIcon";
import { EmailValidIcon } from "../CommonUI/Icon/EmailValidIcon";
import { NotEmptyIcon } from "../CommonUI/Icon/NotEmptyIcon";
import { TextLengthIcon } from "../CommonUI/Icon/TextLengthIcon";
import { LowercaseIcon } from "../CommonUI/Icon/LowercaseIcon";
import { NotContainsIcon } from "../CommonUI/Icon/NotContainsIcon";
import { ProperIcon } from "../CommonUI/Icon/ProperIcon";
import { TrimIcon } from "../CommonUI/Icon/TrimIcon";
import { UppercaseIcon } from "../CommonUI/Icon/UppercaseIcon";
import { DateAddXExpression } from "../rule-engine-core/Expressions/Expressions/Date/DateAddXExpression";
import { DateSubtractXExpression } from "../rule-engine-core/Expressions/Expressions/Date/DateSubtractXExpression";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import { DateNowExpression } from "../rule-engine-core/Expressions/Expressions/Date/DateNowExpression";
import { DateAddXExpressionEditor } from "./Expressions/Date/DateAddXExpressionEditor";
import { DateNowExpressionEditor } from "./Expressions/Date/DateNowExpressionEditor";
import { DateSubtractXExpressionEditor } from "./Expressions/Date/DateSubtractXExpressionEditor";

export class RegisterExpressionRuleEditors {
    static isRegistered = false;

    static doRegistration() {
        if (RegisterExpressionRuleEditors.isRegistered) return;

        RegisterExpressionRuleEditors.isRegistered = true;

        RegisterExpressionRuleEditor(new RootExpressionEditor(), new RootExpression(), <AbsoluteIcon />);

        RegisterExpressionRuleEditor(new AbsoluteExpressionEditor(), new AbsoluteExpression(), <AbsoluteIcon />);

        RegisterExpressionRuleEditor(
            new DateEqualToExpressionEditor(),
            new DateEqualToExpression(),
            <DateEqualToIcon />,
        );

        RegisterExpressionRuleEditor(
            new DateGetDayExpressionEditor(),
            new DateGetDayExpression(),
            <TextIcon name="D" />,
        );
        RegisterExpressionRuleEditor(
            new DateGetHourExpressionEditor(),
            new DateGetHourExpression(),
            <TextIcon name="H" />,
        );
        RegisterExpressionRuleEditor(
            new DateGetMinuteExpressionEditor(),
            new DateGetMinuteExpression(),
            <TextIcon name="m" />,
        );
        RegisterExpressionRuleEditor(
            new DateGetMonthExpressionEditor(),
            new DateGetMonthExpression(),
            <TextIcon name="M" />,
        );
        RegisterExpressionRuleEditor(
            new DateGetSecondExpressionEditor(),
            new DateGetSecondExpression(),
            <TextIcon name="s" />,
        );
        RegisterExpressionRuleEditor(
            new DateGetTodayExpressionEditor(),
            new DateGetTodayExpression(),
            <TextIcon name="D" />,
        );
        RegisterExpressionRuleEditor(
            new DateGetYearExpressionEditor(),
            new DateGetYearExpression(),
            <TextIcon name="Y" />,
        );
        RegisterExpressionRuleEditor(
            new DateGreaterThanExpressionEditor(),
            new DateGreaterThanExpression(),
            <DateGreaterThanIcon />,
        );
        RegisterExpressionRuleEditor(
            new DateLessThanExpressionEditor(),
            new DateLessThanExpression(),
            <DateLessThanIcon />,
        );
        RegisterExpressionRuleEditor(new DateAddXExpressionEditor(), new DateAddXExpression(), <EditCalendarIcon />);
        RegisterExpressionRuleEditor(
            new DateSubtractXExpressionEditor(),
            new DateSubtractXExpression(),
            <EventBusyIcon />,
        );
        RegisterExpressionRuleEditor(new DateNowExpressionEditor(), new DateNowExpression(), <InsertInvitationIcon />);

        RegisterExpressionRuleEditor(new ExistsExpressionEditor(), new ExistsExpression(), <ExistsIcon />);
        RegisterExpressionRuleEditor(
            new GreaterThanExpressionEditor(),
            new GreaterThanExpression(),
            <GreaterThanIcon />,
        );
        RegisterExpressionRuleEditor(
            new GreaterThanEqualToExpressionEditor(),
            new GreaterThanEqualToExpression(),
            <GreaterThanEqualIcon />,
        );
        RegisterExpressionRuleEditor(new AndGroupEditor(), new AndGroup(), <AndIcon />);
        RegisterExpressionRuleEditor(new OrGroupEditor(), new OrGroup(), <OrIcon />);
        RegisterExpressionRuleEditor(new IfThenExpressionEditor(), new IfThenExpression(), <IfThenIcon />);
        RegisterExpressionRuleEditor(new IsFalseExpressionEditor(), new IsFalseExpression(), <IsFalseIcon />);
        RegisterExpressionRuleEditor(new IsTrueExpressionEditor(), new IsTrueExpression(), <IsTrueIcon />);
        RegisterExpressionRuleEditor(new LessThanExpressionEditor(), new LessThanExpression(), <LessThanIcon />);
        RegisterExpressionRuleEditor(
            new LessThanEqualToExpressionEditor(),
            new LessThanEqualToExpression(),
            <LessThanEqualIcon />,
        );
        RegisterExpressionRuleEditor(new NotExpressionEditor(), new NotExpression(), <NotIcon />);

        RegisterExpressionRuleEditor(new AddExpressionEditor(), new AddExpression(), <PlusOutlineIcon />);
        RegisterExpressionRuleEditor(
            new AsCurrencyExpressionEditor(),
            new AsCurrencyExpression(),
            <AsPercentageIcon />,
        );
        RegisterExpressionRuleEditor(
            new AsPercentageExpressionEditor(),
            new AsPercentageExpression(),
            <AsPercentageIcon />,
        );
        RegisterExpressionRuleEditor(new AverageExpressionEditor(), new AverageExpression(), <AverageIcon />);
        RegisterExpressionRuleEditor(new DivideExpressionEditor(), new DivideExpression(), <DevideIcon />);
        RegisterExpressionRuleEditor(new EqualExpressionEditor(), new EqualExpression(), <EqualIcon />);
        RegisterExpressionRuleEditor(new MaxExpressionEditor(), new MaxExpression(), <MaxIcon />);
        RegisterExpressionRuleEditor(new MinExpressionEditor(), new MinExpression(), <MinIcon />);
        RegisterExpressionRuleEditor(new ModExpressionEditor(), new ModExpression(), <ModIcon />);
        RegisterExpressionRuleEditor(new MultiplyExpressionEditor(), new MultiplyExpression(), <MultiplyIcon />);
        RegisterExpressionRuleEditor(new SubstractExpressionEditor(), new SubstractExpression(), <SubstractIcon />);
        RegisterExpressionRuleEditor(new SumExpressionEditor(), new SumExpression(), <SumIcon />);
        RegisterExpressionRuleEditor(new NotEqualExpressionEditor(), new NotEqualExpression(), <NotEqualIcon />);
        RegisterExpressionRuleEditor(new RandomExpressionEditor(), new RandomExpression(), <RandomIcon />);
        RegisterExpressionRuleEditor(new RoundExpressionEditor(), new RoundExpression(), <RoundIcon />);

        RegisterExpressionRuleEditor(
            new StringCombineExpressionEditor(),
            new StringCombineExpression(),
            <CombineIcon />,
        );
        RegisterExpressionRuleEditor(
            new StringContainsExpressionEditor(),
            new StringContainsExpression(),
            <TextContainsIcon />,
        );
        RegisterExpressionRuleEditor(new StringEqualExpressionEditor(), new StringEqualExpression(), <EqualIcon />);
        RegisterExpressionRuleEditor(
            new StringEndWithExpressionEditor(),
            new StringEndWithExpression(),
            <StartWithIcon />,
        );
        RegisterExpressionRuleEditor(
            new StringIndexOfExpressionEditor(),
            new StringIndexOfExpression(),
            <IndexOfIcon />,
        );
        RegisterExpressionRuleEditor(
            new StringIsEmptyExpressionEditor(),
            new StringIsEmptyExpression(),
            <TextEmptyIcon />,
        );
        RegisterExpressionRuleEditor(
            new StringIsValidEmailExpressionEditor(),
            new StringIsValidEmailExpression(),
            <EmailValidIcon />,
        );
        RegisterExpressionRuleEditor(
            new StringLengthExpressionEditor(),
            new StringLengthExpression(),
            <TextLengthIcon />,
        );
        RegisterExpressionRuleEditor(
            new StringIsNotEmptyExpressionEditor(),
            new StringIsNotEmptyExpression(),
            <NotEmptyIcon />,
        );
        RegisterExpressionRuleEditor(
            new StringLowercaseExpressionEditor(),
            new StringLowercaseExpression(),
            <LowercaseIcon />,
        );
        RegisterExpressionRuleEditor(
            new StringNotContainsExpressionEditor(),
            new StringNotContainsExpression(),
            <NotContainsIcon />,
        );
        RegisterExpressionRuleEditor(new StringProperExpressionEditor(), new StringProperExpression(), <ProperIcon />);
        RegisterExpressionRuleEditor(
            new StringStartWithExpressionEditor(),
            new StringStartWithExpression(),
            <StartWithIcon />,
        );
        RegisterExpressionRuleEditor(new StringTrimExpressionEditor(), new StringTrimExpression(), <TrimIcon />);
        RegisterExpressionRuleEditor(
            new StringUppercaseExpressionEditor(),
            new StringUppercaseExpression(),
            <UppercaseIcon />,
        );

        RegisterExpressionRuleEditor(
            new StringListCombineExpressionEditor(),
            new StringListCombineExpression(),
            <CombineIcon />,
        );
        RegisterExpressionRuleEditor(
            new StringListContainsExpressionEditor(),
            new StringListContainsExpression(),
            <TextContainsIcon />,
        );
        RegisterExpressionRuleEditor(
            new StringListGetStringByIndexExpressionEditor(),
            new StringListGetStringByIndexExpression(),
            <CombineIcon />,
        );
        RegisterExpressionRuleEditor(
            new StringListInExpressionEditor(),
            new StringListInExpression(),
            <TextContainsIcon />,
        );
        RegisterExpressionRuleEditor(
            new StringListNotAllInExpressionEditor(),
            new StringListNotAllInExpression(),
            <NotContainsIcon />,
        );
        RegisterExpressionRuleEditor(
            new StringListNotContainsExpressionEditor(),
            new StringListNotContainsExpression(),
            <NotContainsIcon />,
        );
        RegisterExpressionRuleEditor(
            new StringListNotInExpressionEditor(),
            new StringListNotInExpression(),
            <NotContainsIcon />,
        );
        RegisterExpressionRuleEditor(
            new StringListAllInExpressionEditor(),
            new StringListAllInExpression(),
            <TextContainsIcon />,
        );
    }
}
